import { useContext } from "react";

import { useResolutionsApi } from "../../../../../common/api/orders-api/resolution/useResolutionsApi";
import { ResolutionsListingContext } from "../../../context/ResolutionsListingContext";
import { CreateResolutionFormInputs } from "./CreateResolutionForm";

export const useCreateResolutionForm = () => {
    const { createResolution: createRes } = useResolutionsApi();
    const { add: addResolutionToContext } = useContext(ResolutionsListingContext);

    const createResolution = async (inputs: CreateResolutionFormInputs) => {
        const response = await createRes({
            height: inputs.height,
            width: inputs.width
        });

        addResolutionToContext({
            id: response.entityId,
            height: inputs.height,
            width: inputs.width,
            name: `${inputs.width} x ${inputs.height}`
        });
    };

    return {
        createResolution
    };
};
